import { AZURE_URL } from "../constants/env-constants";

export const getAllTeams = async () => {
  try {
    const response = await AZURE_URL.get("/staff/team/get/all");
    if (response.status === 200) {
      return [response.data, null];
    } else {
      return [null, response];
    }
  } catch (error: any) {
    return [null, "Server Error: " + error.response];
  }
};

export const deleteTeam = async (id: string) => {
  try {
    const response = await AZURE_URL.delete(
      `/staff/team/delete?publicId=${id}`
    );

    if (response.status === 200) {
      return [response, null];
    } else {
      return [null, response];
    }
  } catch (error: any) {
    console.log(error);
    return [null, "Server Error: " + error.message];
  }
};

export const createNewTeam = async (data: CreateTeamRequest) => {
  try {
    const response = await AZURE_URL.post("/staff/team/create", data);

    if (response?.status >= 200 && response.status < 300) {
      return [response.data, null];
    } else {
      return [null, response];
    }
  } catch (error: any) {
    console.log(error);
    return [null, error.response.data];
  }
};
